export function getSearchingGames(game) {
    const round_number = (val) => Math.floor(( parseFloat(val) + Number.EPSILON) * 100) / 100;
    if(!game.odd){
        return ''
    }
    if(game.type_id == 1){
        const odd_one = game.odd.split(',').length > 0 ? game.odd.split(',')[0] : '';
        const odd_x = game.odd.split(',').length > 1 ? game.odd.split(',')[1] : '';
        const odd_two = game.odd.split(',').length > 2 ? game.odd.split(',')[2] : '';

        
        const odd_one_val = odd_one ? round_number(odd_one.split('|')[1]) : 1;
        const odd_x_val = odd_x ? round_number(odd_x.split('|')[1]) : 1;
        const odd_two_val = odd_two ? round_number(odd_two.split('|')[1]) : 1;
        
        return `<div class="moduleSportSingleLeagueMatch" id=${game.id}>
          <div class="moduleSportSingleLeagueMatchLabel">
            <a class="moduleSportSingleLeagueMatchLink" href="#/match/${game.id}">
              <span class="moduleSingleMatchName"><i>${game.home_team}</i> <i>${game.away_team}</i> </span>
              <span class="moduleSingleResult"></span>
              <span>${game.game_time}</span>
              <span class="numberofmarkets">${game.count_options} ></span>
            </a>
            <div class="moduleSportSingleLeagueAccordionEvent">
              <svg class="accordionIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                 <g>
                   <g>
                     <path d="M505.752,123.582c-8.331-8.331-21.839-8.331-30.17,0L256,343.163L36.418,123.582c-8.331-8.331-21.839-8.331-30.17,0    s-8.331,21.839,0,30.17l234.667,234.667c8.331,8.331,21.839,8.331,30.17,0l234.667-234.667    C514.083,145.42,514.083,131.913,505.752,123.582z"></path>
                   </g>
                 </g>
              </svg>
            </div>
          </div>
          <div class="moduleSportSingleLeagueMatchBetButtons">
          <div class="singleHomeOdd bettingBtn  ${odd_one_val == 1 ? 'disabledBtn' : '' } ${odd_one.split(',').length > 0 ? odd_one.split('|')[0] : 'disabledBtn'}" 
                    
                       match-odd="${odd_one ? odd_one_val.toFixed(2) : ""}" 
                       match-home-name="${game.home_team}" 
                       match-away-name="${game.away_team}" 
                       coef-id="${odd_one ? odd_one.split('|')[0] : ""}" 
                       bet-id="${odd_one ? odd_one.split('|')[0] : ""}" 
                       game-id="${game.id}"
                       match-market="${["1", "X", "2"].includes(odd_one.split('|')[2]) ? "Rezultat final" : odd_one.split('|')[2]}"
                       match-market-option="1"
                    >
                    <span>1</span>
                    <span>${odd_one ? odd_one_val.toFixed(2) : ''}</span>
                 </div>
                 <div class="singleDrawOdd bettingBtn  ${odd_x_val <= 1 ? 'disabledBtn' : '' } ${odd_x ? odd_x.split('|')[0] : 'disabledBtn'}" 
                 
                    match-odd="${odd_x ? odd_x_val.toFixed(2) : ''}" 
                    match-home-name="${game.home_team}" 
                    match-away-name="${game.away_team}" 
                    coef-id="${game.odd.split(',').length > 1 ? odd_x.split('|')[0] : ""}" 
                    bet-id="${game.odd.split(',').length > 1 ? odd_x.split('|')[0] : ""}" 
                    game-id="${game.id}"
                    match-market="${["1", "X", "2"].includes(odd_x.split('|')[2]) ? "Rezultat final" : odd_x.split('|')[2]}"
                    match-market-option="X"
                  >
                  <span>X</span>
                  <span>${odd_x ? odd_x_val.toFixed(2) : ""}</span>
                 </div>
                 ${odd_two ? ` 
                 <div class="singleAwayOdd bettingBtn  ${odd_two_val <= 1 ? 'disabledBtn' : '' } ${odd_two ? odd_two.split('|')[0] : 'disabledBtn'}" 
                  match-odd="${odd_two ? odd_two_val.toFixed(2) : ''}" 
                  match-home-name="${game.home_team}" 
                  match-away-name="${game.away_team}" 
                  coef-id="${game.odd.split(',').length > 1 ? odd_two.split('|')[0] : ""}" 
                  bet-id="${game.odd.split(',').length > 1 ? odd_two.split('|')[0] : ""}" 
                  game-id="${game.id}"
                  match-market="${["1", "X", "2"].includes(odd_two.split('|')[2]) ? "Rezultat final" : odd_two.split('|')[2]}"
                  match-market-option="2"
                 >
                 <span>2</span>
                 <span>${odd_two ? odd_two_val.toFixed(2) : ""}</span>
                 </div>` : ``}
          </div>
        </div>`;
    } else {
        const odd_one = game.odd.split(',').length > 0 ? game.odd.split(',')[0] : '';
        const odd_x = game.odd.split(',').length > 1 ? game.odd.split(',')[1] : '';
        const odd_two = game.odd.split(',').length > 2 ? game.odd.split(',')[2] : '';

        
        const odd_one_val = odd_one ? round_number(odd_one.split('|')[1]) : 1;
        const odd_x_val = odd_x ? round_number(odd_x.split('|')[1]) : 1;
        const odd_two_val = odd_two ? round_number(odd_two.split('|')[1]) : 1;

        return `<div class="moduleSportSingleLeagueMatch" id=${game.id}>
          <div class="moduleSportSingleLeagueMatchLabel">
            <a class="moduleSportSingleLeagueMatchLink" href="#/livematch/${game.id}?sportId=1">
              <span class="moduleSingleMatchName"><i>${game.home_team}</i> <i>${game.away_team}</i> </span>
              <span class="moduleSingleResult">${game.result}</span>
              <span>${game.game_time}</span>
              <span class="numberofmarkets">${game.count_options} ></span>
            </a>
            <div class="moduleSportSingleLeagueAccordionEvent">
              <svg class="accordionIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                 <g>
                   <g>
                     <path d="M505.752,123.582c-8.331-8.331-21.839-8.331-30.17,0L256,343.163L36.418,123.582c-8.331-8.331-21.839-8.331-30.17,0    s-8.331,21.839,0,30.17l234.667,234.667c8.331,8.331,21.839,8.331,30.17,0l234.667-234.667    C514.083,145.42,514.083,131.913,505.752,123.582z"></path>
                   </g>
                 </g>
              </svg>
            </div>
          </div>
          <div class="moduleSportSingleLeagueMatchBetButtons">
          
            <div class="betHomeButton bettingBtn ${odd_one ? odd_one.split("|")[1] : "disabledBtn"} ${odd_one_val  == 1 ? 'disabledBtn' : '' }" match-odd="${odd_one_val}" match-home-name="${game.home_team}" match-away-name="${game.away_team}" coef-id="${odd_one.split('|')[0]}" bet-id="${odd_one.split('|')[0]}" game-id="${game.id}" match-market-option="1"
              match-market="${["1", "X", "2"].includes(odd_one.split('|')[2]) ? "Rezultat final" : odd_one.split('|')[2]}">
              <span>1</span>
              <span>${odd_one_val.toFixed(2)}</span>
            </div>
            <div class="betDrawButton bettingBtn ${odd_x ? odd_x.split("|")[1] : "disabledBtn"} ${odd_x && odd_x_val  == 1 ? 'disabledBtn' : '' }" match-odd="${odd_x_val}" match-home-name="${game.home_team}" match-away-name="${game.away_team}" coef-id="${odd_x.split('|')[0]}" bet-id="${odd_x ? odd_x.split('|')[0]: ""}" game-id="${game.id}" match-market-option="X"
              match-market="${["1", "X", "2"].includes(odd_x.split('|')[2]) ? "Rezultat final" : odd_x.split('|')[2]}">
              <span>X</span>
              <span>${odd_x_val.toFixed(2)}</span>
            </div>
            <div class="betAwayButton bettingBtn ${odd_two ? odd_two.split("|")[1] : "disabledBtn"} ${ odd_two && odd_two_val  == 1 ? 'disabledBtn' : '' }" match-odd="${odd_two ? odd_two_val : "1.00"}" match-home-name="${game.home_team}" match-away-name="${game.away_team}" coef-id="${odd_two ? odd_two.split('|')[0] :""}" bet-id="${odd_two ? odd_two.split('|')[0] :""}" game-id="${game.id}" match-market-option="2"
              match-market="${["1", "X", "2"].includes(odd_two.split('|')[2]) ? "Rezultat final" : odd_two.split('|')[2]}">
              <span>2</span>
              <span>${odd_two_val.toFixed(2)}</span>
            </div>
          </div>
        </div>`;
    }
}